import { useEffect, useState } from 'react';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from '@sentry/react';
import { ThemeProvider } from 'styled-components';
import { ToastProvider } from './components/Toast';
import { LayerProvider } from './contexts/layer';
import Path from './Path';
import dayTheme from './themes/day';
import Error from './components/Error';
import client from './utilities/client';

const App = () => {
  const [layers, setLayers] = useState([]);

  useEffect(() => {
    if (!localStorage.getItem('featureFlags')) {
      const whether = Math.random() < 0.5 ? true : false;

      localStorage.setItem(
        'featureFlags',
        JSON.stringify({
          newIcons: whether,
        })
      );
    }
  });

  return (
    <ApolloProvider client={client}>
      <ThemeProvider theme={dayTheme}>
        <ToastProvider>
          <LayerProvider
            value={{
              layers,
              setLayers,
            }}
          >
            <ErrorBoundary fallback={Error}>
              <BrowserRouter>
                <Path />
              </BrowserRouter>
            </ErrorBoundary>
          </LayerProvider>
        </ToastProvider>
      </ThemeProvider>
    </ApolloProvider>
  );
};

export default App;
